import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import { VolumeInput } from 'common/entity/components/volume/VolumeInput';

import { Volume, VolumeUnitType } from 'common/models/internal/Volume';
import {
    Dimensions,
    preferredUnitsForDistance,
    sourceUnitForDistance
} from 'common/models/internal/Dimensions';

import defaultTheme from './Dimensions.scss';

class DimensionsComponent extends PureComponent {
    render() {
        const {
            volume,
            dimensions,
            error,
            hideVolumeInput,
            t,
            theme,
            onChange,
            onDimensionsChange,
            volumeUnit,
            unitConverter,
            distanceUnit = unitConverter.getPreferredUnit({
                preferredUnits: preferredUnitsForDistance,
                sourceUnit: sourceUnitForDistance
            }),
            preferredVolumeUnit
        } = this.props;
        return (
            <VolumeInput
                t={t}
                hideVolumeInput={hideVolumeInput}
                theme={theme}
                translationsObject={{
                    volumeLabel: 'vehicleModelForm.volume',
                    volumeTitle: 'vehicleModelForm.volumeType',
                    volumeHelpText: 'vehicleModelForm.volumeHelpText'
                }}
                deletable={false}
                volume={
                    volume ||
                    Volume.fromJS({
                        unit: VolumeUnitType.MetersCubic,
                        value: null
                    })
                }
                dimensions={
                    dimensions ||
                    Dimensions.fromJS({
                        length: null,
                        breadth: null,
                        height: null
                    })
                }
                error={error}
                onChange={onChange}
                onDimensionsChange={onDimensionsChange}
                volumeUnit={volumeUnit}
                distanceUnit={distanceUnit}
                preferredVolumeUnit={preferredVolumeUnit}
                showVolumeUnit
            />
        );
    }
}

export default themr('EntityDimensions', defaultTheme)(DimensionsComponent);
